import { Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QueryDeleteModel } from 'src/app/core/models/QueryDeleteModel';
import { QueryRequestModel } from 'src/app/core/models/QueryRequestModel';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-delete-query',
  standalone: false,
  templateUrl: './delete-query.component.html',
  styleUrl: './delete-query.component.less'
})
export class DeleteQueryComponent implements OnInit {
  //@Input() selectedQuery!: QueryRequestModel;
  readonly nzModalData = inject(NZ_MODAL_DATA);
  paramRequestModel: QueryRequestModel = new QueryRequestModel();
  queryToDelete: QueryDeleteModel = new QueryDeleteModel();
  currentUser!: User;
  public deleteQueryForm!: FormGroup; // Reactive Form
  public maxCharacters = 200; // Maximum characters for the Comment field
  constructor(
    //private router: Router,
    private userService: UserService,
    private queryService: ClarificationQueryListService,
    private modalService: NzModalService,
    private messageService: NzMessageService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.paramRequestModel = this.nzModalData.paramRequestModel;    
    
    // Initialize the Reactive Form
    this.InitializeDeleteQueryForm();

    // Initialize the queryToDelete model
    this.assignInitialDeleteInfo();
  }
  InitializeDeleteQueryForm() {
    this.deleteQueryForm = this.fb.group({
      deleteComments: [
        '', // Default value
        [Validators.required, Validators.maxLength(this.maxCharacters)] // Validators
      ]
    });
  }
  assignInitialDeleteInfo() {
    this.currentUser = this.userService.getCurrentUser();
    this.queryToDelete = {
      DeletedBy: this.currentUser.User_Code ?? 0,
      IsDeletedByPartner: this.currentUser.Is_Partner ?? false,
      QueryCode: this.paramRequestModel.QueryCode,
      QueryDetailCode: this.paramRequestModel.QueryDetailCode,
      Comment: '' // Initialize Comment
    };
  }
  onDeleteQuery() {
    this.messageService.loading('Deleting query...');
    if (this.deleteQueryForm.valid) {
      // Update the Comment field in the queryToDelete model
      this.queryToDelete.Comment = this.deleteQueryForm.value.deleteComments;
      
      // Call the service to delete the query
      this.queryService.deleteQuery(this.queryToDelete).subscribe({
        next: () => {
          this.messageService.success('Query deleted successfully.');
          this.modalService.closeAll();
          //this.router.navigate(['/queries']);
        },
        error: (err) => {
          console.error('Error deleting query:', err);
          this.messageService.error('Failed to delete the query. Please try again.');
        }
      });
    }
  }

  
  onCancel() {
    this.modalService.closeAll();
  }
}
